// extracted by mini-css-extract-plugin
export default {"aboutPage":"AboutPage_aboutPage__VQFdl","pageTitle":"AboutPage_pageTitle__B0156","titleText":"AboutPage_titleText__WVmed","titleLogo":"AboutPage_titleLogo__CMi2D"};